import { Empty, Table } from "antd";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { routes } from "../../routes.ts";
import type { ProducerFragment } from "../../gql/generated/graphqlSchema.tsx";

type UsedInRecipe = ProducerFragment["usedInRecipes"][number];

export const ProducerUsedInRecipesTab = ({ producer }: { readonly producer: ProducerFragment }) => {
  const { t } = useTranslation();
  const rows = producer.usedInRecipes;

  return (
    <Table<UsedInRecipe>
      columns={[
        {
          title: t("recipes.name"),
          key: "name",
          render: (_, row) => <Link to={routes.recipeDetail.to(row.id)}>{row.name}</Link>,
        },
      ]}
      dataSource={rows}
      locale={{ emptyText: <Empty description={t("producers.usedInRecipesEmpty")} /> }}
      pagination={false}
      rowKey="id"
      size="small"
    />
  );
};
